import { render, staticRenderFns } from "./MewBlockie.vue?vue&type=template&id=673b03a9&scoped=true"
import script from "./MewBlockie.vue?vue&type=script&lang=js"
export * from "./MewBlockie.vue?vue&type=script&lang=js"
import style0 from "./MewBlockie.vue?vue&type=style&index=0&id=673b03a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b03a9",
  null
  
)

export default component.exports